import OrbTextEditor from './orb-text-editor';

export default OrbTextEditor;